import { render, staticRenderFns } from "./clinic.vue?vue&type=template&id=ad21d088&scoped=true&"
import script from "./clinic.vue?vue&type=script&lang=js&"
export * from "./clinic.vue?vue&type=script&lang=js&"
import style0 from "./clinic.vue?vue&type=style&index=0&id=ad21d088&prod&scoped=true&lang=css&"
import style1 from "./clinic.vue?vue&type=style&index=1&id=ad21d088&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad21d088",
  null
  
)

export default component.exports